// Global theme configuration - Change colors here to reflect across all pages
export const theme = {
  colors: {
    primary: '#2E7D32',      // Green
    secondary: '#1976D2',    // Blue
    accent: '#FBC02D',       // Yellow
    dark: '#1a1a1a',
    light: '#f5f5f5',
    white: '#ffffff',
    text: '#333333',
    textLight: '#666666'
  },
  gradients: {
    primary: 'linear-gradient(135deg, #2E7D32 0%, #1976D2 100%)',
    secondary: 'linear-gradient(135deg, #1976D2 0%, #FBC02D 100%)',
    accent: 'linear-gradient(135deg, #FBC02D 0%, #2E7D32 100%)'
  },
  shadows: {
    small: '0 2px 8px rgba(0,0,0,0.1)',
    medium: '0 4px 16px rgba(0,0,0,0.15)',
    large: '0 8px 32px rgba(0,0,0,0.2)'
  },
  borderRadius: {
    small: '8px',
    medium: '12px',
    large: '16px'
  }
};

export const siteInfo = {
  companyName: 'SRI KRISH CIVIL SUPPLIER',
  email: 'srikrishcivilsupplier@gmail.com',
  phone: '9894065756',
  location: 'Coimbatore, Tamil Nadu',
  tagline: 'Your Trusted Partner in Civil Construction',
  description: 'Leading civil construction supplier in Coimbatore specializing in building demolition, earthwork, and high-quality building materials.',
  social: {
    instagram: 'https://www.instagram.com/_srikrish.civil.supplier_?igsh=MWw5eHR1N3prc3Ruag==',
    youtube: 'https://youtube.com/@srikrishcivilsupplier?si=n7Iy0oE6VDyGNKsh',
    facebook: 'https://www.facebook.com/profile.php?id=61589189503770'
  }
};
